import LifeStyleImage from "@/components/LifeStyleImages.vue";

export const lifeStyleImagesInit = {
    component: LifeStyleImage,
    name: "Life Style Images",
    inputs: [
        {
            name: "lifeStyleImages",
            friendlyName: "Images",
            type: "array",
            defaultValue: [],
            subFields: [
                {
                    name: "image",
                    friendlyName: "Image",
                    allowedFileTypes: ["jpeg", "jpg", "png"],
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "alt",
                    friendlyName: "Alt Text",
                    type: "string",
                    defaultValue: ""
                }
            ]
        }
    ]
};
